import type { IframeHTMLAttributes } from 'react';

export const PRODUCT_NAME = 'embed_v2';

export const EMBED_DEFAULT_HEIGHT = 352;
export const EMBED_LANDSCAPE_HEIGHT = 152;
export const EMBED_IFRAME_DEFAULT_WIDTH = '100%';
export const OEMBED_BORDER_RADIUS = '12px';
export const OEMBED_WIDTH = 456;
export const EMBED_VIDEO_IFRAME_DEFAULT_WIDTH = 624;
export const EMBED_VIDEO_IFRAME_DEFAULT_HEIGHT = 351;
export const EMBED_VIDEO_IFRAME_COMPACT_WIDTH = 496;
export const EMBED_VIDEO_IFRAME_COMPACT_HEIGHT = 279;

export const MAX_EMBED_HEIGHT = 352;

export const EMBED_REQUIRED_IFRAME_ATTRIBUTES: IframeHTMLAttributes<HTMLIFrameElement> =
  {
    /* 
	 START: deprecated attributes
	 These attributes are either not supported or deprecated, and anyhow NOT part of HTML5 spec 
	 We don't add them anymore as they're only supported in old version of IE < 9
	 */

    // The value 0 removes the border around this frame
    frameBorder: 0,

    // AllowTransparency is not even supported by IE9
    // allowTransparency: true,

    /* END deprecated attrs */

    // This attribute is considered a legacy attribute and redefined as allow="fullscreen"
    // We have both for now in order to deprecate this
    allowFullScreen: true,

    allow: [
      // 'accelerometer',
      // 'gyroscope',
      'autoplay', // Needed to be able to autoplay when embed widget is mounted
      'clipboard-write', // We copy the link into user clipboard
      'encrypted-media', // Some podcasts have DRM encrypted content
      'fullscreen', // In the embed-video, you can put the video full-screen
      'picture-in-picture', //  In an hyptotetical future, in embed-video, you can put the video PiP
    ].join('; '),

    loading: 'lazy',
  };
